import React, { useEffect } from 'react';

function MessageBox({ message, type = 'info', onClose, children }) {
    useEffect(() => {
        if (message) {
            document.body.style.overflow = 'hidden';
        }
        return () => {
            document.body.style.overflow = 'unset';
        };
    }, [message]);
    
    if (!message) return null;
    return (
        <div className="fixed inset-0 bg-gray-600 bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white p-6 rounded-lg shadow-xl max-w-sm w-full text-center">
                <p className={`text-lg font-semibold ${type === 'error' ? 'text-red-600' : 'text-gray-800'}`}>{message}</p>
                {children || (
                    <button
                        onClick={onClose}
                        className="mt-4 px-6 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 transition duration-200"
                    >
                        OK
                    </button>
                )}
            </div>
        </div>
    );
}

export default MessageBox;
